import { TAWUNIYA } from '@/src/constants/itinerary/insurance'
import useInsurance from '@/src/hooks/itinerary/useInsurance'
import { Box, Divider, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import InsuranceCard from './InsuranceCard'
export const benefitsIcons = [
    'https://ui.cltp.co/assets/insurance-accident.png',
    'https://ui.cltp.co/assets/rt_ia2.png',
    'https://ui.cltp.co/assets/insurance-accident.png',
    'https://ui.cltp.co/assets/Green_ba43ed82c0.png',
    'https://ui.cltp.co/assets/baggage1.avif',
    'https://ui.cltp.co/assets/baggage2.png',
    'https://ui.cltp.co/assets/insurance-accident.png'
]
const TAWUNIYAInsuranceWrapper = () => {
    const { insuranceList, selectedInsurances, handleInsuranceClick } = useInsurance()
    const t = useTranslations('common')
    const tawuniyaInsuranceList = insuranceList.filter(insurance => insurance.vasProvider === TAWUNIYA)

    if (!tawuniyaInsuranceList.length) {
        return null
    }
    return (
        <>
            <Box mt={2}>
                <Divider />
                <Typography
                    variant="h6"
                    sx={{
                        fontWeight: 600,
                        color: 'textColors.primary',
                        fontSize: { xs: '16px', md: '1.25rem' },
                        mt: 2
                    }}
                >
                    {t('tawuniyaInsuranceTitle')}
                </Typography>
                <Box mt={2} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    {tawuniyaInsuranceList.map((insurance, index) => {
                        const isSelected = selectedInsurances.some(
                            selectedInsurance => selectedInsurance.vasType === insurance.vasType
                        )

                        const onInsuranceClick = () => {
                            handleInsuranceClick(insurance, isSelected ? 'REMOVE' : 'ADD')
                        }

                        return (
                            <Box key={`${insurance.vasType}_${index}`}>
                                <InsuranceCard
                                    insurance={insurance}
                                    isSelected={isSelected}
                                    onInsuranceClick={onInsuranceClick}
                                    index={index}
                                />
                            </Box>
                        )
                    })}
                </Box>
            </Box>
        </>
    )
}

export default TAWUNIYAInsuranceWrapper
